[
  {
    "id": "overworld-day",
    "category": "wallpaper",
    "name": "Overworld Day",
    "rarity": "starter",
    "coinPrice": 0
  },
  {
    "id": "sunset",
    "category": "wallpaper",
    "name": "Sunset",
    "rarity": "rare",
    "coinPrice": 500,
    "creator": "Crimson",
    "license": "None",
    "sourceUrl": "https://hdqwalls.com/minecraft-sunset-wallpaper",
    "assetPath": "/fallback/cosmetics/wallpapers/sunset.png"
  },
  {
    "id": "blocky-little-world",
    "category": "wallpaper",
    "name": "Blocky Little World",
    "rarity": "epic",
    "coinPrice": 750,
    "creator": "Djesic",
    "license": "Unsplash License",
    "sourceUrl": "https://unsplash.com/photos/a-toy-building-made-of-building-blocks-7OdqCWOiYoQ",
    "assetPath": "/fallback/cosmetics/wallpapers/blocky-little-world.png"
  }
]
